<template>
  <article class="wrapper wrapper-content main-column full-column">
    <section class="animated fadeInRight">
      <div class="ibox">
        <div class="ibox-title">
          <div class="ibox-tools">
              <span class="info-menu">
                  <!-- プロフィール -->
                  {{ $t("viewName.profile") }}
              </span>
              <span class="info-right">
                <template v-if="this.edit == false">
                    <button class="btn btn-primary" @click="setEdit">{{$t('editStr')}}</button>
                </template>
                <template v-else>
                    <button class="btn btn-danger" @click="cancelProfileEdit">{{$t('cancelStr')}}</button>
                    <button class="btn btn-success"  @click="updateProfile">{{$t('saveStr')}}</button>
                </template>
              </span>
            </div>
          </div>
        </div>
        <!-- UserElement -->
        <div class="ibox-child">
            <div class="flex-box">
              <!-- {{ this.editInfo.userIcon }} -->
                <span v-if="edit == false" class="info-profimg cursor">
                    <img v-if="this.userIcon" :src="this.userIcon" :alt="this.userName" class="img-circle">
                    <img v-else :src="'static/img/noImage.png'" alt="noImage" class="img-circle">
                </span>
                <span v-else class="info-profimg cursor" v-b-modal.profileModal>
                    <img v-if="this.editInfo.userIcon" :src="this.editInfo.userIcon" :alt="editInfo.userName" class="img-circle">
                    <img v-else :src="'static/img/noImage.png'" alt="noImage" class="img-circle">
                </span>

                <div class="profile-box">
                    <div class="info-profelement ibox-child row">
                        <label class="col-md-4">{{$t('profileUserTitle')}}</label>
                        <div class="col-md-8">
                            <template v-if="edit == false">
                                <span>{{ this.userName }}</span>
                            </template>
                            <template v-else>
                                <input type="text" class="form-control" v-bind:class="{willysmForm: willysmEnabled}" v-model="editInfo.userName">
                                <span v-if=!this.vName class="text-danger font-bold">{{$t('alertRequiredItemStr')}}</span>
                            </template>
                        </div>
                    </div>
                    <div class="info-profelement ibox-child row">
                        <label class="col-md-4">{{$t('departmentStr')}}</label>
                        <div class="col-md-8">
                            <template v-if="edit == false">
                                <span> {{ this.userDept }}</span>
                            </template>
                            <template v-else>
                                <input type="text" v-bind:class="{willysmForm: willysmEnabled}" class="form-control" v-model="editInfo.dept">
                            </template>
                        </div>
                    </div>
                </div>
                <span class="info-statusimg dropdown">
                    <template v-if="edit == false">
                      <profile-drop-down  v-on:set-feeling="updateFeeling" :feeling="this.userFeeling"/>
                    </template>
                    <template v-else>
                      <profile-drop-down v-on:set-feeling="updateFeeling" :feeling="editInfo.userFeeling"/>
                    </template>
                </span>
            </div>
        </div>
        <!-- /UserElement -->
        <!-- Comment -->
        <div class="ibox-child">
            <div class="row">
                <div class="form-group col-sm-12">
                    <label class="control-label">{{$t('profileBioTitle')}}</label>
                      <template v-if="edit == false">
                      <!-- <span class="prof-item">{{ this.userBio }}</span> -->
                      <span v-html="this.rUserBio" v-linkified class="prof-item"></span>
                    </template>
                    <template v-else>
                        <textarea class="form-control" :placeholder="$t('settingBioStr')" rows="3" v-model="editInfo.userBio"></textarea>
                    </template>
                </div>
            </div>
        </div>
        <!-- /Comment -->

        <!-- Mail -->
        <div class="ibox-child">
            <div class="row">
                <div id="limited" class="date form-group col-sm-3">
                    <label class="control-label">{{$t('profileMailTitle')}}</label>
                </div>
                <div class="form-group col-sm-9">
                    <div class="input-group">
                          <template v-if="edit == false">
                              <span><a :href='"mailto:" + this.userEmail'>{{ this.userEmail }}</a></span>
                        </template>
                        <template v-else>
                            <span class="badge bg-danger">{{$t('notChange')}}</span>
                            <span>{{ this.userEmail }}</span>
                        </template>
                    </div>
                </div>
            </div>
        </div>
        <!-- /Mail -->
        <!-- Tell -->
        <div class="ibox-child">
            <div class="row">
                <div id="limited" class="date form-group col-sm-3">
                    <label class="control-label">{{$t('profilePhoneTitle')}}</label>
                </div>
                <div class="form-group col-sm-9">
                    <div class="input-group">
                        <template v-if="edit == false">
                            <span><a :href='"tel:" + this.userPhone'>{{ this.userPhone }}</a></span>
                        </template>
                        <template v-else>
                            <input type="text" class="form-control" v-model="editInfo.userPhone">
                            <span class="text-danger font-bold">{{$t('noHyphenStr')}}</span>
                        </template>
                    </div>
                </div>
            </div>
        </div>
        <!-- /Tell -->

        <!-- Carrer -->
        <div class="ibox-child">
            <div class="row">
                <div class="form-group col-sm-12">
                    <label class="control-label">{{$t('profileSummarayTitle')}}</label>
                    <span class="prof-item">
                        <template v-if="edit == false">
                          <span class="prof-item">
                            <div class="comment">
                              <read-more :text="this.careerSummary" :addMore="true" :detailView="false" :showMore="this.propShowMore" :contentHeight="this.propContentHeight" @update-show-more="updateShowMore" @update-content-height="updateContentHeight">
                                {{ this.careerSummary }}
                              </read-more>
                            </div>
                          </span>
                        </template>
                        <template v-else>
                            <textarea class="form-control" :placeholder="$t('profileSummarayTitle')" rows="5" v-model="editInfo.careerSummary"></textarea>
                        </template>
                    </span>
                </div>
            </div>
        </div>
        <!-- /Carrer -->
      </div>
    </section>
    <b-modal id="profileModal" :title="$t('changePictureStr')" :ok-title="$t('uploadPictureStr')" ref="modal" @hide="handleClickEvent">
      <!-- :file-size-limit="2097152" -->
      <!-- @file-size-exceed="onFileSizeExceed" -->
        <croppa v-model="myCroppa"
            :width="300"
            :height="300"
            :show-remove-button="true"
            remove-button-color="black"
            :show-loading="true"
            :placeholder="$t('chooseAnImageStr')"
            :placeholder-font-size="16"
            :prevent-white-space="true"
            :accept="'image/*'"
            @file-type-mismatch="onFileTypeMismatch">
            </croppa>
    </b-modal>
  </article>
</template>

<script>
import {storage, willysm} from '@/main'
import moment from 'moment'
import linkify from 'vue-linkify'
import ProfileDropDown from '@/components/User/ProfileDropDown'
import ReadMore from '@/components/ReadMore/ReadMoreComponent'

export default {
  name: 'ProfileItems',
  components: {
    ProfileDropDown,
    ReadMore
  },
  directives: {
    linkified: linkify
  },
  props: ['userIcon', 'userName', 'userDept', 'userFeeling', 'userEmail', 'userPhone', 'careerSummary', 'userBio', 'rUserBio', 'edit', 'vName'],
  data: function () {
    return {
      tag: 'progress',
      willysmEnabled: willysm.enabled,
      editInfo: {
        userName: '',
        dept: '',
        userFeeling: '',
        userBio: '',
        userEmail: '',
        userPhone: '',
        careerSummary: ''
      },
      uploadImage: '',
      cropImage: '',
      myCroppa: {},
      propShowMore: false,
      propContentHeight: 0
    }
  },
  methods: {
    setEdit: function () {
      // 編集中データをセット
      this.editInfo = {
        userName: this.userName,
        userFeeling: this.userFeeling,
        userEmail: this.userEmail,
        userPhone: this.userPhone,
        dept: this.userDept,
        userBio: this.userBio,
        careerSummary: this.careerSummary,
        userIcon: this.userIcon
      }
      this.$emit('start-edit', this.editInfo)
    },
    updateFeeling: function (value) {
      // コンディションの変更
      if (this.edit) {
        this.editInfo.userFeeling = value
      } else {
        this.setFeeling(value)
      }
    },
    handleClickEvent: function (evt) {
      if ((evt.trigger === 'backdrop' || evt.trigger === 'cancel' || evt.trigger === 'header-close') && this.myCroppa.imageSet) {
        evt.preventDefault()
        if (confirm(this.$t('confirmDeletePictureStr'))) {
          this.removeCroppa()
        }
      } else if ((evt.trigger === 'backdrop' || evt.trigger === 'cancel' || evt.trigger === 'header-close') && !this.myCroppa.imageSet) {
        this.$refs.modal.hide()
      } else if (evt.trigger === 'ok' && !this.myCroppa.imageSet) {
        evt.preventDefault()
        alert(this.$t('selectPictureStr'))
      } else if (evt.trigger === 'ok' && this.myCroppa.imageSet) {
        this.uploadResizedPhoto()
      }
    },
    removeCroppa: function () {
      this.myCroppa.remove()
      this.$refs.modal.hide()
    },
    // プロフィール画像プロップ処理
    onFileTypeMismatch (file) {
      const $t = this.$t
      this.swal({
        text: $t('orderFileUploadStr'),
        type: 'waning',
        animation: false,
        customClass: 'animated pulse'
      })
    },
    uploadResizedPhoto () {
      var date = moment()
      let userId = this.getUserId
      var profileImageUrl = (date / 1000) + '.jpg'
      const storageProfilePhotoRef = storage.ref('profilepictures/' + userId)
      const path = profileImageUrl
      const photoImagesRef = storageProfilePhotoRef.child(path)
      // console.log('ここ', photoImagesRef)
      this.myCroppa.generateBlob((blob) => {
        photoImagesRef.put(blob)
          .then((snapshot) => {
            snapshot.ref.getDownloadURL().then((url) => {
              this.editInfo.userIcon = url
            })
          })
          .catch((err) => {
            console.log('upload error:', err)
          })
      })
    },
    updateProfile: function () {
      this.$emit('set-profileItems', this.editInfo)
    },
    checkName: function () {
      this.$emit('check-name', this.editInfo.userName)
    },
    cancelProfileEdit: function () {
      this.$emit('cancel-profileEdit')
    },
    updateShowMore: function (value) {
      this.propShowMore = value
    },
    updateContentHeight: function (value) {
      this.propContentHeight = value
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
span.text-danger {
  display: inline-block;
  width: 100%;
  margin: 0.5rem 0;
}
.willysmForm {
width: 88%;
}
</style>



// WEBPACK FOOTER //
// src/components/User/ProfileItems.vue